import {
  GET_PARTNERTHEME_FAILED,
  GET_PARTNERTHEME_LOADING,
  GET_PARTNERTHEME_REMOVE,
  GET_PARTNERTHEME_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  status: null,
  themeData: null,
  request: null,
};

export const partnerThemeCrudOperationsReducer = (
  state = initialState,
  action: {
    type: any;
    loading: any;
    payload: any;
    status: any;
    error: any;
    request: string;
  }
) => {
  switch (action.type) {
    case GET_PARTNERTHEME_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_PARTNERTHEME_SUCCESS:
      return {
        ...state,
        loading: false,
        themeData: action.payload,
        status: action.status,
        error: null,
        request: action.request,
      };
    case GET_PARTNERTHEME_FAILED:
      return {
        ...state,
        loading: false,
        status: action.status,
        error: action.error,
        request: action.request,
      };

    case GET_PARTNERTHEME_REMOVE:
      return initialState;

    default:
      return state;
  }
};
